module.exports = __webpack_public_path__ + "7f7aeb545cf14ebf96e92211d300cc76.svg";